import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoginModalOpen: false,
};

const loginModalSlice = createSlice({
  name: 'loginModal',
  initialState,
  reducers: {
    toggleLoginModal(state, action) {
      state.isLoginModalOpen = action.payload;
    },
  },
});

export const { toggleLoginModal } = loginModalSlice.actions;
export default loginModalSlice.reducer;
